import { add } from './add';
import { remove } from './delete';

export default {
  add,
  remove,
};
